const NOT_FOUND_TXT = '404';

export const erIkkeJeger = (errorText) => errorText.includes(NOT_FOUND_TXT);

